import { Action, createReducer, on } from '@ngrx/store';
import { parseStr } from '@shared/helpers';
import { ISelectedAccount } from '@shared/models';
import {
  UpdateMinorTransferSelectedAccountFrom,
  UpdateMinorTransferSelectedAccountTo,
  UpdateMinorTransferTotalTransferValue,
} from '@store/actions';

export interface MinorTransferState {
  transferFrom: {
    selectedAccount: ISelectedAccount[];
    totalTransferValue: string;
  };
  transferTo: {
    selectedAccount: ISelectedAccount;
  };
}

export const initialState: MinorTransferState = {
  transferFrom: {
    selectedAccount: null,
    totalTransferValue: '',
  },
  transferTo: {
    selectedAccount: null,
  },
};

const configReducer = createReducer(
  initialState,
  on(UpdateMinorTransferSelectedAccountFrom, (state, { payload }) => ({
    ...state,
    transferFrom: {
      ...state.transferFrom,
      ...payload,
    },
  })),
  on(UpdateMinorTransferSelectedAccountTo, (state, { payload }) => ({
    ...state,
    transferTo: {
      ...state.transferTo,
      ...payload,
    },
  })),
  on(UpdateMinorTransferTotalTransferValue, (state, { payload }) => ({
    ...state,
    transferFrom: {
      ...state.transferFrom,
      totalTransferValue: payload,
    },
  })),
);

export function reducer(state: MinorTransferState | undefined, action: Action) {
  return configReducer(state, action);
}

export const getMinorTransferFrom = (state: MinorTransferState) =>
  state ? state.transferFrom : null;

export const getMinorTransferTotalTransferValue = (state: MinorTransferState) =>
  state ? state.transferFrom.totalTransferValue : null;

export const getMinorTransferTo = (state: MinorTransferState) => (state ? state.transferTo : null);

export const calculateMinorTransferTransferTotal = (selectedAccounts: ISelectedAccount[]) => {
  return selectedAccounts.reduce((accumulated, accounts) => {
    return accumulated + parseStr(accounts.accountData.balance || '0');
  }, 0);
};
